import PropTypes from 'prop-types';
import React from 'react';
import { noop } from 'src/components/base';
import * as S from './styles';

class Checkbox extends React.PureComponent {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  handleOnChange = e => {
    this.props.onChange({
      id: this.props.id,
      value: this.props.child.id,
      name: this.props.child.name,
      checked: e.currentTarget.checked,
      children: this.props.child.children,
      parents: this.props.parents,
      autoSelectChildren: this.props.autoSelectChildren,
    });
  };

  render() {
    return (
      <S.HiddenInput
        checked={this.props.isChecked}
        onChange={this.handleOnChange}
        type="checkbox"
        value={this.props.child.id}
      />
    );
  }
}

const { oneOfType, arrayOf, string, bool, shape, func, number, object } =
  PropTypes;

const valueType = {
  id: string.isRequired,
  name: string.isRequired,
  products: number,
};

valueType.children = arrayOf(shape(valueType));

Checkbox.propTypes = {
  child: object.isRequired,
  onChange: func,
  id: oneOfType([number, string]).isRequired,
  parents: arrayOf(shape(valueType)),
  autoSelectChildren: bool,
  isChecked: bool.isRequired,
};

Checkbox.defaultProps = {
  parents: [],
  onChange: noop,
  autoSelectChildren: true,
};

export default Checkbox;
